import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Label, FormFeedback, FormGroup } from 'reactstrap'
import DatePicker from 'react-datepicker'
import _ from 'lodash'

export default class FormikDateField extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    dateFormat: PropTypes.string,
  }
  static defaultProps = {
    readOnly: false,
    dateFormat: 'yyyy-MM-dd',
  }

  render() {
    const props = this.props
    const value = props.values[props.name]
    let dateValue = moment(value).toDate()
    // eslint-disable-next-line
    if (dateValue == 'Invalid Date') {
      dateValue = null
    }
    const error = _.get(props.errors, props.name)
    const isInvalid = error && _.get(props.touched, props.name)
    return (
      <FormGroup>
        <Label>{props.label || props.children}</Label>
        <div>
          <DatePicker
            autoComplete="off"
            className="form-control"
            dateFormat={props.dateFormat}
            disabled={props.disabled || props.isSubmitting}
            invalid={isInvalid}
            maxDate={new Date('2050-01-01T00:00:00')}
            minDate={new Date('2000-01-01T00:00:00')}
            name={props.name}
            onChange={date => props.setFieldValue(props.name, date)}
            readOnly={props.readOnly}
            selected={dateValue}
          />
        </div>
        <FormFeedback>{error}</FormFeedback>
      </FormGroup>
    )
  }
}
